<template>
    <Teleport to="body">
        <Transition name="drawer-left">
            <div v-show="isOpen" class="fixed inset-0 z-50 overflow-hidden">
                <div 
            class="absolute inset-0 bg-black/20 backdrop-blur-sm" 
            @click="$emit('close', 'overlay')"
        ></div>

                <div class="absolute inset-y-0 left-0 w-full max-w-xl bg-white shadow-2xl flex flex-col">
                    <div class="p-6 border-b flex justify-between items-center">
                        <h3 class="text-xl font-bold text-gray-800">{{ title }}</h3>
                        <button @click="$emit('close', 'button')" class="text-gray-400 hover:text-gray-600 transition-colors p-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>
                    </div>

                    <div class="flex-grow p-0 overflow-y-auto">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </Transition>
    </Teleport>
</template>

<script setup>
/* global defineProps, defineEmits */
// defineProps({
//     isOpen: Boolean,
//     title: String
// });
defineProps(['isOpen', 'title']);
defineEmits(['close']);
</script>

<style scoped>
/* 修改动画方向：从左侧划入/划出 */
.drawer-left-enter-active,
.drawer-left-leave-active {
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 进场前和离场后的状态：向左偏移 100% */
.drawer-left-enter-from,
.drawer-left-leave-to {
    transform: translateX(-100%);
    opacity: 0;
}
</style>